const URL_BASE = "http://imob86.concept.inf.br/Imob86/Vue"

const ARQUIVOS_UPLOAD = URL_BASE + "/Arquivos/Gravar"
const ARQUIVOS_REMOVER = URL_BASE + "/Arquivos/Remover"

const BAIRROS_LISTAR = URL_BASE + "/Bairros/Listar";

const CARACTERISTICAS_CONDOMINIO_LISTAR = URL_BASE + "/CaracteristicasCondominio/Listar";
const CARACTERISTICAS_IMOVEL_LISTAR = URL_BASE + "/CaracteristicasImovel/Listar";

const CIDADES_LISTAR = URL_BASE + "/Cidades/Listar";

const CLIENTES_LISTAR = URL_BASE + "/Clientes/Listar";
const CLIENTES_RECUPERAR = URL_BASE + "/Clientes/Recuperar";
const CLIENTES_GRAVAR = URL_BASE + "/Clientes/Gravar";
const CLIENTES_REMOVER = URL_BASE + "/Clientes/Remover";
const CLIENTES_GRAVAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/GravarContatoRealizado";
const CLIENTES_ATUALIZAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/AtualizarContatoRealizado";
const CLIENTES_REMOVER_CONTATO_REALIZADO = URL_BASE + "/Clientes/RemoverContatoRealizado";
const CLIENTES_GRAVAR_CONTA_BANCARIA = URL_BASE + "/Clientes/GravarContaBancaria";
const CLIENTES_REMOVER_CONTA_BANCARIA = URL_BASE + "/Clientes/RemoverContaBancaria";
const CLIENTES_RECUPERAR_VISITA = URL_BASE + "/Clientes/RecuperarVisita";
const CLIENTES_GRAVAR_VISITA = URL_BASE + "/Clientes/GravarVisita";
const CLIENTES_REMOVER_VISITA = URL_BASE + "/Clientes/RemoverVisita";

const CONDOMINIOS_LISTAR = URL_BASE + "/Condominios/Listar";

const DASHBOARD_LISTAR_IMOVEIS_MAPA = URL_BASE + "/Dashboard/ListarImoveisMapa";

const FORMULARIOS_GERAR = URL_BASE + "/Formularios/Gerar";
const FORMULARIOS_GERAR_RECIBO_COMISSAO = URL_BASE + "/Formularios/GerarReciboComissao";
const FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO = URL_BASE + "/Formularios/GerarReciboComissaoUnico";
const FORMULARIOS_RECUPERAR = URL_BASE + "/Formularios/Recuperar";
const FORMULARIOS_RECUPERAR_PERGUNTAS = URL_BASE + "/Formularios/RecuperarPerguntas";
const FORMULARIOS_CRIAR_DIRETORIO = URL_BASE + "/Formularios/CriarDiretorio";
const FORMULARIOS_REMOVER_DIRETORIO = URL_BASE + "/Formularios/RemoverDiretorio";
const FORMULARIOS_LISTAR_DIRETORIOS = URL_BASE + "/Formularios/ListarDiretorios";
const FORMULARIOS_SELECIONAR_DIRETORIO = URL_BASE + "/Formularios/SelecionarDiretorio";

const IMOVEIS_LISTAR = URL_BASE + "/Imoveis/Listar";
const IMOVEIS_RECUPERAR = URL_BASE + "/Imoveis/Recuperar";
const IMOVEIS_GRAVAR =  URL_BASE + "/Imoveis/Gravar";
const IMOVEIS_DISPONIBILIZAR = URL_BASE + "/Imoveis/Disponibilizar";
const IMOVEIS_INDISPONIBILIZAR = URL_BASE + "/Imoveis/Indisponibilizar";
const IMOVEIS_ARQUIVAR = URL_BASE + "/Imoveis/Arquivar";
const IMOVEIS_REMOVER = URL_BASE + "/Imoveis/Remover";
const IMOVEIS_RECUPERAR_VISITA = URL_BASE + "/Imoveis/RecuperarVisita";
const IMOVEIS_GRAVAR_VISITA = URL_BASE + "/Imoveis/GravarVisita";
const IMOVEIS_REMOVER_VISITA = URL_BASE + "/Imoveis/RemoverVisita";
const IMOVEIS_RESERVAR_IMOVEL = URL_BASE + "/Imoveis/ReservarImovel";
const IMOVEIS_DESFAZER_RESERVA = URL_BASE + "/Imoveis/DesfazerReserva";

const LOGGER_LISTAR = URL_BASE + "/Logger/Listar";

const OBSERVACOES_RECUPERAR = URL_BASE + "/Observacoes/Recuperar";
const OBSERVACOES_GRAVAR = URL_BASE + "/Observacoes/Gravar";
const OBSERVACOES_REMOVER = URL_BASE + "/Observacoes/Remover";

const PLACAS_LISTAR = URL_BASE + "/Placas/Listar";
const PLACAS_GRAVAR_PLACA_NO_IMOVEL = URL_BASE + "/Placas/GravarPlacaNoImovel";
const PLACAS_REMOVER_PLACA_DO_IMOVEL = URL_BASE + "/Placas/RemoverPlacaDoImovel";

const RELATORIOS_GERAR = URL_BASE + "/Relatorios/Gerar";
const RELATORIOS_ENVIAR_POR_EMAIL = URL_BASE + "/Relatorios/EnviarPorEmail"

const USUARIOS_LISTAR = URL_BASE + "/Usuarios/Listar";

const VALIDAR_ACESSO = URL_BASE + "/Usuarios/ValidarAcesso";

const VENDAS_APROVAR = URL_BASE + "/Vendas/Aprovar";
const VENDAS_DESAPROVAR = URL_BASE + "/Vendas/Desaprovar";
const VENDAS_GRAVAR = URL_BASE + "/Vendas/Gravar";
const VENDAS_REMOVER = URL_BASE + "/Vendas/Remover";
const VENDAS_LISTAR = URL_BASE + "/Vendas/Listar";
const VENDAS_RECUPERAR = URL_BASE + "/Vendas/Recuperar";
const VENDAS_PAGAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/PagarPagamentoComissao"; 
const VENDAS_PAGAR_COMISSAO_COMPLETA = URL_BASE + "/Vendas/PagarComissaoCompleta";
const VENDAS_GRAVAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/GravarPagamentoComissao";
const VENDAS_CANCELAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/CancelarPagamentoComissao";
const VENDAS_REMOVER_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/RemoverPagamentoComissao";

export default {
  ARQUIVOS_UPLOAD,
  ARQUIVOS_REMOVER,

  BAIRROS_LISTAR,

  CARACTERISTICAS_CONDOMINIO_LISTAR,
  CARACTERISTICAS_IMOVEL_LISTAR,

  CIDADES_LISTAR,

  CLIENTES_LISTAR,
  CLIENTES_RECUPERAR,
  CLIENTES_GRAVAR,
  CLIENTES_REMOVER,
  CLIENTES_GRAVAR_CONTATO_REALIZADO,
  CLIENTES_ATUALIZAR_CONTATO_REALIZADO,
  CLIENTES_REMOVER_CONTATO_REALIZADO,
  CLIENTES_GRAVAR_CONTA_BANCARIA,
  CLIENTES_REMOVER_CONTA_BANCARIA,
  CLIENTES_RECUPERAR_VISITA,
  CLIENTES_GRAVAR_VISITA,
  CLIENTES_REMOVER_VISITA,

  CONDOMINIOS_LISTAR,

  DASHBOARD_LISTAR_IMOVEIS_MAPA,

  FORMULARIOS_GERAR,
  FORMULARIOS_GERAR_RECIBO_COMISSAO,
  FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO,
  FORMULARIOS_RECUPERAR,
  FORMULARIOS_RECUPERAR_PERGUNTAS,
  FORMULARIOS_CRIAR_DIRETORIO,
  FORMULARIOS_REMOVER_DIRETORIO,
  FORMULARIOS_LISTAR_DIRETORIOS,
  FORMULARIOS_SELECIONAR_DIRETORIO,

  IMOVEIS_LISTAR,
  IMOVEIS_RECUPERAR,
  IMOVEIS_GRAVAR,
  IMOVEIS_DISPONIBILIZAR,
  IMOVEIS_INDISPONIBILIZAR,
  IMOVEIS_ARQUIVAR,
  IMOVEIS_REMOVER,
  IMOVEIS_RECUPERAR_VISITA,
  IMOVEIS_GRAVAR_VISITA,
  IMOVEIS_REMOVER_VISITA,
  IMOVEIS_RESERVAR_IMOVEL,
  IMOVEIS_DESFAZER_RESERVA,

  LOGGER_LISTAR,

  OBSERVACOES_RECUPERAR,
  OBSERVACOES_GRAVAR,
  OBSERVACOES_REMOVER,

  PLACAS_LISTAR,
  PLACAS_GRAVAR_PLACA_NO_IMOVEL,
  PLACAS_REMOVER_PLACA_DO_IMOVEL,

  RELATORIOS_GERAR,
  RELATORIOS_ENVIAR_POR_EMAIL,

  USUARIOS_LISTAR,

  VALIDAR_ACESSO,

  VENDAS_APROVAR,
  VENDAS_DESAPROVAR,
  VENDAS_GRAVAR,
  VENDAS_REMOVER,
  VENDAS_LISTAR,
  VENDAS_RECUPERAR,
  VENDAS_PAGAR_PAGAMENTO_COMISSAO,
  VENDAS_PAGAR_COMISSAO_COMPLETA,
  VENDAS_GRAVAR_PAGAMENTO_COMISSAO,
  VENDAS_CANCELAR_PAGAMENTO_COMISSAO,
  VENDAS_REMOVER_PAGAMENTO_COMISSAO
}